import SEO from './SEO.container';
export default SEO;